// extracted by mini-css-extract-plugin
module.exports = {"badge":"ContingentBadge_badge___DvFy"};